<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{ $route.query.account_group == 1 ? 'Account Field' : 'Transaction Field' }}</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

            <v-layout wrap padding-top-bottom-ten white-background>
	            <v-flex xs12 sm12 md12 form-item>
		           	<v-text-field 
		           		v-model="Form.name" 
		           		label="Name" 
		           		placeholder=" " 
		           		v-validate="'required'" 
		           		data-vv-name="name" 
		           		:error-messages="errors.collect('name')" 
		           		required>
		           	</v-text-field>
		        </v-flex>
		        <v-flex xs12 sm12 md12 form-item>
		           	<v-text-field 
		           		@click="fn_openDialogWeb('web', 'Field', 'ref_fieldType')" 
		               	readonly 
		               	v-model="fieldName" 
		               	label="Field Type" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="ref_fieldTypeTextBox">
		           	</v-text-field>
		        </v-flex>

		        <!-- Max length -->
		        <v-flex xs12 sm12 md12 form-item v-if="showMaxLength">
		           	<v-text-field 
		           		v-model="Form.additionalDataObject.maxLength" 
		           		type="number" 
		           		label="Max Length" 
		           		placeholder=" " 
		           		v-validate="'required|numeric|min_value:1'" 
		           		data-vv-name="maxlength" 
		           		:error-messages="errors.collect('maxlength')" 
		           		required>
		           	</v-text-field>
		        </v-flex>

		        <!-- Choice -->
		        <div v-if="showChoice" form-item>
		        	<v-flex xs12 sm12 md12>
			        	<v-text-field v-model="Form.additionalDataObject.choiceText" label="Enter Choice Item" placeholder=" ">
							<v-btn icon flat small color="primary" nomargin slot="append-outer" @click="fn_addChoice">Add</v-btn>
				        </v-text-field>
			        </v-flex>

			        <div class="error--text" v-if="invalidFields && !Form.additionalDataObject.choices.length">
			        	Add minimum one choice!
			        </div>

			        <v-chip close label outline v-for="(choice, index) in Form.additionalDataObject.choices" :key="index" @click="fn_selectChoice(choice)" @input="fn_removeChoice(index, choice)" :color="Form.additionalDataObject.defaultChoice == choice ? 'primary' : ''">
			        	{{choice}}
			    	</v-chip>
		        </div>	

		        <!-- Yes/No -->
		        <v-flex xs12 sm12 md12 v-if="showDefaultValue" form-item>
		           	<v-checkbox right-align-checkbox label="Default Value" v-model="Form.additionalDataObject.defaultValue"></v-checkbox>
		        </v-flex>

		        <!-- Code -->
		        <v-layout wrap v-if="showCode">
		        	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.additionalDataObject.codeMode" row>
					      <v-radio label="Manual" :value="1"></v-radio>
					      <v-radio label="Auto" :value="0"></v-radio>
					    </v-radio-group>
			        </v-flex>

			        <v-flex xs12 sm12 md12 v-if="Form.additionalDataObject.codeMode" form-item>
		               	<v-text-field 
		               		v-model="Form.additionalDataObject.codeLength" 
		               		type="number" 
		               		label="Code Length" 
		               		placeholder=" "
		               		v-validate="'required|max:9'" 
		               		data-vv-name="codelength" 
		               		:error-messages="errors.collect('codelength')" 
		               		required>
		               			
		               	</v-text-field>
		            </v-flex>

		            <v-layout wrap v-else>
		            	<v-flex xs12 sm12 md12 form-item>
			               	<v-text-field 
			               		v-model="Form.additionalDataObject.prefix" 
			               		label="Prefix" 
			               		placeholder=" ">
			               			
			               	</v-text-field>
			            </v-flex>
			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field 
			               		v-model="Form.additionalDataObject.nextCode" 
			               		label="Next Code" 
			               		placeholder=" " 
			               		type="number"
			               		v-validate="'required|max:9'" 
		               			data-vv-name="nextcode" 
			               		:error-messages="errors.collect('nextcode')" 
			               		required>
			               	</v-text-field>
			            </v-flex>
			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field 
			               		v-model="Form.additionalDataObject.suffix" 
			               		label="Suffix" 
			               		placeholder=" ">
			               	</v-text-field>
			            </v-flex>
		            </v-layout wrap>
		        </v-layout wrap>

		        <!-- Linked Item -->
		        <v-layout wrap v-if="showList">
		        	<v-flex xs12 sm12 md12 form-item>

		               <v-text-field  
		               		@click="fn_openLists('android', 'List', 'ref_fieldLists')"
			               	readonly 
			               	v-model="Form.listName" 
			               	label="List" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldLists"
			               	:onUpdate="fn_updateList"
			               	v-validate="'required'" 
		           			data-vv-name="list" 
		               		:error-messages="errors.collect('list')" 
		               		required>
		               </v-text-field>
		            </v-flex>
		        </v-layout>

		        <!-- Group Field -->
		        <v-layout wrap v-if="showGroupField">
		        	<v-flex xs12 sm12 md12 form-item>

		               <v-text-field  
			               	readonly 
			               	v-model="Form.additionalDataObject.groupFieldName" 
			               	label="Group Field" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldGroup"
			               	v-validate="'required'" 
		           			data-vv-name="group" 
		               		:error-messages="errors.collect('group')" 
		               		required>
		               </v-text-field>
		            </v-flex>

		            <v-flex xs12 sm12 md12 form-item>
			           	<v-checkbox right-align-checkbox label="Multiple" v-model="Form.additionalDataObject.groupMultiple"></v-checkbox>
			        </v-flex>
		        </v-layout wrap>

		        <!-- Account Item (Account Group) -->
		        <v-layout row wrap v-if="showAccountGroup">
		         	<v-flex xs12 sm12 md12 form-item>

			           <v-text-field 
			           		@click="fn_openAccountGroups('android', 'AccountGroup', 'ref_fieldAccountGroup')" 
			               	readonly 
			               	v-model="Form.accountGroupName" 
			               	label="Account Group" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldAccountGroup"
			               	:onUpdate="fn_updateAccountGroup"
			               	v-validate="'required'" 
			       			data-vv-name="accountGroup" 
			           		:error-messages="errors.collect('accountGroup')" 
			           		required>
			           </v-text-field>
			        </v-flex>
		        </v-layout>	

		        <!-- Required -->
		        <v-flex xs12 sm12 md12 form-item v-if="false">
		           	<v-checkbox right-align-checkbox label="Required" v-model="Form.isRequired"></v-checkbox>
		        </v-flex>
            </v-layout>

            <div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>	

        </v-form>

	    <v-dialog v-model="loading" no-click-animation no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	    <dialog-field-types ref="ref_fieldType" :setFieldType="fn_setFieldType" :dataTypes="dataTypes" :fieldType="Form.fieldType"></dialog-field-types>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	</div>
</template>

<script>
const dialogjs =  require('../masters/forms/dialog').dialogjs;
const menuItem = require('../../config.js').configs.menuItem;

const dataTypes = require('../../config.js').configs.dataTypes;

const fieldModel = require('./datamodel.js').data.fieldModel

import fieldTypeDialog from './dialog_fieldtype';

import dialogDiscard from '../dialogs/dialog_discard'
import {draftMixin} from '../draft_mixin'
// import dialogDraftItems from '../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:JSON.parse(JSON.stringify(fieldModel)),
				dataTypes:JSON.parse(JSON.stringify(dataTypes)),
				fieldName:"Text",
				loading:false,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,
				showMaxLength:false, 
				showChoice: false, 
				showDefaultValue: false, 
				showCode:false, 
				showList: false, 
				showGroupField:false, 
				showAccountGroup:false,

				invalidFields:false
			}
		},
		components:{
			'dialog-field-types': fieldTypeDialog,
			'dialog-discard': dialogDiscard,
			// 'dialog-draft-items': dialogDraftItems
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openLists: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select List";

				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newList"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				let listId = this.Form.listId;
				let listName = this.Form.listName;

				if(listId && listName){
					paramObject.defaultValue = {"id":listId, "name":listName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'lists', tagId, paramObject, ref);
			},

			fn_openAccountGroups: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Account Group";

				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newAccountGroup"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				let accountGroupId = this.Form.accountGroupId;
				let accountGroupName = this.Form.accountGroupName;

				if(accountGroupId && accountGroupName){
					paramObject.defaultValue = {"id":accountGroupId, "name":accountGroupName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);
			},

			fn_updateList: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.listId = selectedValueId;
					this.Form.listName = selectedValueName;
					this.errors.remove('fields.list');
				}
				else{
					this.Form.listId = null;
					this.Form.listName = null;
				}
				this.$forceUpdate();
			},

			fn_updateAccountGroup: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountGroupId = selectedValueId;
					this.Form.accountGroupName = selectedValueName;
					this.errors.remove('fields.accountGroup');
				}
				else{
					this.Form.accountGroupId = null;
					this.Form.accountGroupName = null;
				}
				this.$forceUpdate();
			},

			fn_addChoice: function () {
				if(this.Form.additionalDataObject.choiceText){

					let itemIndex = this.Form.additionalDataObject.choices.findIndex(choice=>{
						return choice == this.Form.additionalDataObject.choiceText.trim();
					})

					if(itemIndex!=-1){
						this.showToast("This choice already exists");
						return;
					}

					this.Form.additionalDataObject.choices.push(this.Form.additionalDataObject.choiceText.trim());

					if(this.Form.additionalDataObject.choices.length==1){
						this.Form.additionalDataObject.defaultChoice = this.Form.additionalDataObject.choiceText;
					}

					this.Form.additionalDataObject.choiceText = null;
				}
			},

			fn_selectChoice: function(choice){
				this.$set(this.Form.additionalDataObject, 'defaultChoice', choice);
			},

			fn_removeChoice: function (index, choice) {
				this.Form.additionalDataObject.choices.splice(index, 1);

				if(this.Form.additionalDataObject.defaultChoice == choice){
					if(this.Form.additionalDataObject.choices.length)
						this.$set(this.Form.additionalDataObject, 'defaultChoice', this.Form.additionalDataObject.choices[0]);
					else
						this.$set(this.Form.additionalDataObject, 'defaultChoice', null);

					this.$forceUpdate();
				}
			},

			fn_setMaxLength: function (value) {
				switch (value) {
				    case "text":
				        this.Form.additionalDataObject.maxLength = 50;
				        break;
				    case "pincode":
				        this.Form.additionalDataObject.maxLength = 6;
				        break;
				    case "mobileNumber":
				        this.Form.additionalDataObject.maxLength = 12;
				        break;
				    case "email":
				        this.Form.additionalDataObject.maxLength = 250;
				        break;
				    case "longText":
				        this.Form.additionalDataObject.maxLength = 250;
				        break;
				    case "number":
				        this.Form.additionalDataObject.maxLength = 10;
				        break;
				    case "decimal":
				        this.Form.additionalDataObject.maxLength = 10;
				        break;
				    case "phoneNumber":
				        this.Form.additionalDataObject.maxLength = 100;
				        break;
				    default:
				    	this.Form.additionalDataObject.maxLength = null;
				}
			},

			fn_setFieldVisibility: function (setMaxLength) {
				let value = this.Form.fieldType;

				if(value=='text' || value=='pincode' || value=='mobileNumber' || value=='email' || value=='longText' || value=='number' || value=='decimal' || value=='phoneNumber'){
					setMaxLength ? this.fn_setMaxLength(value) : '';
					this.showMaxLength = true;
				}
				else{
					this.showMaxLength = false;
					this.Form.additionalDataObject.maxLength = null;
				}

				if(value=='choice'){
					this.showChoice = true;
				}
				else{
					this.showChoice = false;
				}

				if(value=='yes/no'){
					this.showDefaultValue = true;
				}
				else{
					this.showDefaultValue = false;
				}

				if(value=='code'){
					this.showCode = true;
				}
				else{
					this.showCode = false;
				}

				if(value=='linkedItem'){
					this.showList = true;
				}
				else{
					this.showList = false;
				}

				if(value=='groupField'){
					this.showGroupField = true;
				}
				else{
					this.showGroupField = false;
				}

				if(value=='accountItem'){
					this.showAccountGroup = true;
				}
				else{
					this.showAccountGroup = false;
				}
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialogWeb: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_setFieldType: function (fieldType) {
				this.Form.fieldType = fieldType;
				this.fieldName = this.fn_getFieldTitle(fieldType);
				// this.Form.fieldType.title = item.title;
				this.fn_setFieldVisibility(true);
				this.fn_closeDialog();
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				let self = this;
		
				var checkRefs = setInterval(function(){
		          if(self.$refs.hasOwnProperty(ref)){

		          	self.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);

		            clearInterval(checkRefs);
		          }
		        },50);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	if(self.Form.fieldType == 'choice' && !self.Form.additionalDataObject.choices.length){
			        		self.showToast('Add minimum one choice');
			        	}
			        	else{
			        		self.fn_post();
			          		return; 
			        	}
			        }
			        else{
			        	self.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Field', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast('Already exists with this name');
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				if(this.$route.query.ls){
					let data = {};
					data.type = 'field';
					//id as fieldId
					data.fieldId = this.Form.fieldId;
					data.name = this.Form.name;
					data.fieldType = this.Form.fieldType;
					data.isRequired = this.Form.isRequired;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.$router.go(-1);
				});
			},

			fn_post: function(){
				// !this.Form.fieldId ? this.Form.fieldId = this.guid() : '';
				if(!this.Form.fieldId){
					this.Form.fieldId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				
				this.Form.name = this.Form.name.trim();

				console.log(this.Form);
				this.Form.additionalData = JSON.stringify(this.Form.additionalDataObject);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false;
				this.getData('Field', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.unwatch = true;
					        var item = JSON.parse(response);

					        item.additionalDataObject = JSON.parse(item.additionalData);

					        self.fn_bindData(item, copyData);

				        }, 
				        onError: function(error){
				         	console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function (item, copyData) {
				this.unwatch = true;
				this.Form.fieldId = item.fieldId;
		        this.Form.name = item.name;
		        this.Form.fieldType = item.fieldType
		        this.fieldName = this.fn_getFieldTitle(item.fieldType);
		        this.Form.isRequired = item.isRequired;

		        this.Form.listId = item.listId;
		        this.Form.listName = item.listName;
		        this.Form.accountGroupId = item.accountGroupId;
		        this.Form.accountGroupName = item.accountGroupName;

		        this.fn_setFieldVisibility(false);

				this.Form.additionalDataObject.maxLength = item.additionalDataObject.maxLength;

				if(this.Form.fieldType == 'choice'){
					this.Form.additionalDataObject.choices = item.additionalDataObject.choices;
					this.Form.additionalDataObject.defaultChoice = item.additionalDataObject.defaultChoice;		
				}

		        this.Form.fieldType == 'yes/no' ? this.Form.additionalDataObject.defaultValue = item.additionalDataObject.defaultValue : '';

		        if(this.Form.fieldType == 'code'){
		        	this.Form.additionalDataObject.codeMode = item.additionalDataObject.codeMode;
		        	if(this.Form.additionalDataObject.codeMode){
			        	this.Form.additionalDataObject.codeLength = item.additionalDataObject.codeLength
			        }
			        else{
			        	this.Form.additionalDataObject.prefix = item.additionalDataObject.prefix;
			        	this.Form.additionalDataObject.nextCode = item.additionalDataObject.nextCode;
			        	this.Form.additionalDataObject.suffix = item.additionalDataObject.suffix;	
			        }
		        }
		        
		        if(this.Form.fieldType=='groupField'){
					this.Form.additionalDataObject.groupId = item.additionalDataObject.groupId;
			        this.Form.additionalDataObject.groupName = item.additionalDataObject.groupName;
			        this.Form.additionalDataObject.groupMultiple = item.additionalDataObject.groupMultiple;					        	
		        }

		        if(this.Form.fieldType=='linkedItem'){
			        this.Form.listName = item.listName;
			        this.Form.additionalDataObject.listMultiple = item.additionalDataObject.listMultiple;
		        }

		        if(this.Form.fieldType=='accountItem'){
		        	this.Form.accountGroupName = item.accountGroupName;
		        }

		        this.Form.isSystem = item.isSystem;

		        if(copyData){
		          	this.Form.fieldId = null;
		   //        	this.snackbar = true;
					// this.snackbar_msg = "Data copied."
					this.showToast("Field copied");
		        }

		        this.$root.fn_copyFormObject(this.Form, this.formId);
			},

			fn_clearForm: function(){
				this.Form = JSON.parse(JSON.stringify(fieldModel));
				this.fn_setFieldVisibility(true);
				this.$validator.reset();
			},	

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newAccountGroup'){
					this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='newList'){
					this.$router.push({path:'/masters/lists/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;
				
				if(this.Form.fieldId){
					this.fn_get(this.Form.fieldId);
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
				
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "accountGroup":
					    	this.fn_updateAccountGroup(itemData.id, itemData.name, false);
					        break;
					    case "list":
					    	this.fn_updateList(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('fieldForms')){
				formsArray = JSON.parse(localStorage.getItem('fieldForms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('fieldForms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

		            if(draft){
						self.Form = JSON.parse(draft.formData);

						self.fn_setFieldVisibility(false);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Field', true) : '';

				});

			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Field');
			this.fn_setDraftData('temp', 'Field');
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();

		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='fieldItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'fieldItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'fieldDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}

		  		// 	!isDraft ? vm.fn_setFieldVisibility(true) : '';
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}

	  			vm.fn_setFieldVisibility(true)
		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('fieldForms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('accountforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('fieldForms')
				// 	next();	
				// }
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/fields/form.vue